export default "__VITE_ASSET__CLj9PYNx__"